/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import GenericElement from '../Utils/GenericElement';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import { getDurationInMinutes, getDurationInMinutesABS, minuteToHHMM, toDateFormat, toISOOffset, workingTimeRounding, setTimeOnDate, addMinutesToDate, getMidpoint } from '../../../Helpers/dateHelper';
import loadJsonPost from '../Utils/jsonPost';
import loadJsonPut from '../Utils/jsonPut';
import { eventBus } from '../Utils/eventBus';
import ModalPopup from '../Common/ModalPopup';
import { useSettings } from 'Helpers/Stores/SettingsProvider';
import InputElement from '../Elements/InputElement';

export function TimeRecordingView(props: any) {
    const [data, setData] = useState(null as any);
    const [timeRecording, setTimeRecording] = useState(0);
    const [startTime, setStartTime] = useState(null as any);
    const [workingType, setWorkingType] = useState('');
    const [running, setRunning] = useState(false);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [workingTypes, setWorkingTypes] = useState(null as any);
    const [showStopConfirm, setShowStopConfirm] = useState(false as any);
    const [addLunchBreak, setAddLunchBreak] = useState(true as any);
    const [extraText, setExtraText] = useState(null as any);
    const [oldWorkingType, setOldWorkingType] = useState(null as any);
    const { systemSettings } = useSettings();

    const [h, m, s] = JSON.parse(localStorage.getItem('UserData') as any)
        .WorkingTimeLunchBreak.split(':')
        .map(Number);
    const minutesToAdd = h * 60 + m + Math.floor(s / 60);
    const [breakFrom, setBreakFrom] = useState<Date>(() => {
        const d = new Date();
        d.setHours(12, 0, 0, 0);
        return d;
    });

    const [breakTo, setBreakTo] = useState<Date>(() => {
        const d = new Date();
        d.setHours(12, 0, 0, 0);
        d.setMinutes(d.getMinutes() + minutesToAdd);
        return d;
    });

    useEffect(() => {
        var username = LocalStorage.getData('UserName');
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetTimeRecordingSummary + '?Data.TargetUser=' + username + '&Data.WorkingUser=' + username + '&Data.Year=' + year + '&Data.KwMonth=' + month).then((data: any) => {
            if (data?.Data?.TimeRecordingSummaryData) {
                setData(prev => ({
                    ...prev,
                    SumWorkingHours: minuteToHHMM(data.Data.TimeRecordingSummaryData.SummeGeleisteteArbeitszeit),
                    SumWorkingHoursPlanned: minuteToHHMM(data.Data.TimeRecordingSummaryData.SummeSollArbeitszeit),
                    SumWorkingHoursPlannedToday: minuteToHHMM(data.Data.TimeRecordingSummaryData.SummeSollArbeitszeitHeute),
                    ConsumedHoliday: data.Data.TimeRecordingSummaryData.SummeUrlaubZeitraum,
                    SumCarryOver: minuteToHHMM(data.Data.TimeRecordingSummaryData.SummeUebertragZeitraum),
                    SumCarryOverToday: minuteToHHMM(data.Data.TimeRecordingSummaryData.SummeUebertragZeitraumHeute),
                    OldHoliday: data.Data.TimeRecordingSummaryData.UrlaubVorKwMonat,
                    CarryOverPrevious: minuteToHHMM(data.Data.TimeRecordingSummaryData.UebertragVorKwMonat),
                    NewHoliday: data.Data.TimeRecordingSummaryData.NeuerUrlaub,
                    RemainingCarryOver: minuteToHHMM(data.Data.TimeRecordingSummaryData.VerbleibenderUebertrag),
                    RemainingCarryOverToday: minuteToHHMM(data.Data.TimeRecordingSummaryData.VerbleibenderUebertragHeute),
                    RemainingHoliday: data.Data.TimeRecordingSummaryData.VerbleibenderUrlaub,
                    Years: data.Data.TimeRecordingSummaryData.Jahre,
                }));
            }
        });

        let start = toDateFormat(new Date(year, month - 1, 1));
        let end = toDateFormat(new Date(year, month, 0));
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetTravelExpenses + '?Data.Filter.BeginDate=' + start + '&Data.Filter.EndDate=' + end).then((data: any) => {
            if (data.Meta.Success && data.Data && data.Data.TravelExpenseData.length > 0) {
                var kmVal = 0;
                var kmPriceVal = 0;
                var dayMoneyVal = 0;
                var pocketExpenseVal = 0;

                data.Data.TravelExpenseData.forEach(expense => {
                    kmVal += expense.Kilometers >= 0 ? expense.Kilometers : 0;
                    kmPriceVal += expense.KilometerCostsTotal >= 0 ? expense.KilometerCostsTotal : 0;
                    dayMoneyVal += expense.DayMoney >= 0 ? expense.DayMoney : 0;
                    pocketExpenseVal += expense.PocketExpenses >= 0 ? expense.PocketExpenses : 0;
                });
                setData(prev => ({
                    ...prev,
                    Km: kmVal,
                    KmPrice: kmPriceVal,
                    DayMoney: dayMoneyVal,
                    PocketExpenses: pocketExpenseVal,
                    ExpenseSum: kmPriceVal + dayMoneyVal + pocketExpenseVal,
                }));
            }
        });

        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetDropdownValues + 'WorkingTimeType').then((data: any) => {
            if (data.Meta.Success && data.Data) {
                setWorkingTypes(data.Data);
            }
            loadTimeRecording();
        });
    }, [year, month]);

    function loadTimeRecording() {
        let today = new Date();
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetTimeRecordingEntries + '?Data.Filter.BeginDate=' + toDateFormat(today) + '&Data.Filter.EndDate=' + toDateFormat(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1))).then((data: any) => {
            if (data.Meta.Success && data.Data && data.Data.TimeRecordingEntriesData) {
                var time = 0;
                var runningVal = false;
                data.Data.TimeRecordingEntriesData.forEach(r => {
                    if (!r.WorkingTimeUntil) {
                        setRunning(true);
                        runningVal = true;
                        setStartTime(r.WorkingTimeFrom);
                        setWorkingType(r.CustomWorkingType + '-' + r.WorkingType);
                    }
                    if (runningVal) time += getDurationInMinutes(r.WorkingTimeFrom, r.WorkingTimeUntil ?? new Date());
                });
                setTimeRecording(Math.trunc(time));
                if (runningVal) {
                    timeTicker();
                } else {
                    setRunning(false);
                }
            }
        });
    }

    function timeTicker() {
        setTimeout(function () {
            setTimeRecording(prev => {
                return Math.trunc(prev + 1);
            });
            timeTicker();
        }, 60000);
    }

    function getValue(keys) {
        if (keys.length === 1) return data[keys[0]];
        else if (keys.length === 2) return [data[keys[0]], data[keys[1]]];
        return '';
    }

    //#region eventBus
    const [eventCounter, setEventCounter] = useState(0);

    useEffect(() => {
        if (eventCounter > 0) {
            loadTimeRecording();
        }
    }, [eventCounter]);

    useEffect(() => {
        registerEventBus();
    }, []);

    function registerEventBus() {
        const handleMessage = msg => {
            setEventCounter(prev => prev + 1);
        };

        eventBus.on('message', handleMessage);

        // Clean up when the component unmounts
        return () => {
            eventBus.off('message', handleMessage);
        };
    }
    const sendMessage = () => {
        eventBus.emit('message', 'Update');
    };

    //#endregion eventBus

    function onStartStop() {
        let today = new Date();
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetTimeRecordingEntries + '?Data.Filter.BeginDate=' + toDateFormat(today) + '&Data.Filter.EndDate=' + toDateFormat(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1))).then((data: any) => {
            if (data.Meta.Success && data.Data && data.Data.TimeRecordingEntriesData) {
                var unfinished = data.Data.TimeRecordingEntriesData.find(r => !r.WorkingTimeUntil);
                var body;
                if (unfinished) {
                    var timeUntil = workingTimeRounding(new Date()) as any;
                    if (
                        addLunchBreak &&
                        JSON.parse(localStorage.getItem('UserData') as any)?.WorkingTimeLunchBreak !== '00:00:00' &&
                        getDurationInMinutesABS(workingTimeRounding(new Date(startTime)), workingTimeRounding(new Date())) >= 360 &&
                        breakTo > breakFrom &&
                        new Date(breakFrom) >= new Date(unfinished.WorkingTimeFrom) &&
                        new Date(breakTo) <= new Date(timeUntil)
                    ) {
                        console.log('AA');
                        const lunchStart = toISOOffset(workingTimeRounding(new Date(breakFrom)));
                        const lunchEnd = toISOOffset(workingTimeRounding(new Date(breakTo)));
                        const breakDurationMinutes = getDurationInMinutes(lunchStart, lunchEnd);
                        timeUntil = toISOOffset(workingTimeRounding(systemSettings.License.LicenseNumber === '999999' ? addMinutesToDate(timeUntil, breakDurationMinutes) : timeUntil));
                        body = {
                            Data: {
                                TimeRecordingEntriesData: [
                                    {
                                        Date: unfinished.Date,
                                        WorkingTimeFrom: unfinished.WorkingTimeFrom,
                                        WorkingTimeUntil: lunchStart,
                                        WorkingType: workingType?.split('-')?.[1] ?? unfinished.WorkingType,
                                        CustomWorkingType: workingType?.split('-')?.[0] ?? unfinished.CustomWorkingType,
                                        Duration: getDurationInMinutes(unfinished.WorkingTimeFrom, lunchStart),
                                        Index: unfinished.Index,
                                        EmployeeIndex: unfinished.EmployeeIndex,
                                        Text: extraText ?? unfinished.Text ?? '',
                                        CanDelete: false,
                                    },
                                ],
                            },
                        };

                        const createBody = {
                            Data: {
                                TimeRecordingEntriesData: [
                                    {
                                        Date: unfinished.Date,
                                        WorkingTimeFrom: lunchEnd,
                                        WorkingTimeUntil: timeUntil, // still using calculated until
                                        WorkingType: workingType?.split('-')?.[1] ?? unfinished.WorkingType,
                                        CustomWorkingType: workingType?.split('-')?.[0] ?? unfinished.CustomWorkingType,
                                        Duration: getDurationInMinutes(lunchEnd, timeUntil),
                                        Index: 0,
                                        EmployeeIndex: 0,
                                        Text: extraText ?? unfinished.Text ?? '',
                                        CanDelete: false,
                                    },
                                ],
                            },
                        };

                        loadJsonPost('/' + LocalStorage.getConnectionKey() + URLS.CreateTimeRecordingEntries, createBody).then((data: any) => {});
                    } else {
                        console.log('BB');

                        body = {
                            Data: {
                                TimeRecordingEntriesData: [
                                    {
                                        Date: unfinished.Date,
                                        WorkingTimeFrom: unfinished.WorkingTimeFrom,
                                        WorkingTimeUntil: timeUntil,
                                        WorkingType: workingType?.split('-')?.[1] ?? unfinished.WorkingType,
                                        CustomWorkingType: workingType?.split('-')?.[0] ?? unfinished.CustomWorkingType,
                                        Duration: getDurationInMinutes(unfinished.WorkingTimeFrom, timeUntil),
                                        Index: unfinished.Index,
                                        EmployeeIndex: unfinished.EmployeeIndex,
                                        Text: extraText ?? unfinished.Text ?? '',
                                        CanDelete: false,
                                    },
                                ],
                            },
                        };
                    }
                    loadJsonPut('/' + LocalStorage.getConnectionKey() + URLS.UpdateTimeRecordingEntries, body).then((data: any) => {
                        setRunning(false);
                        loadTimeRecording();
                        sendMessage();
                    });
                } else {
                    var timeFrom = toISOOffset(workingTimeRounding(new Date()));
                    var date = new Date();
                    date.setHours(0, 0, 0);
                    body = {
                        Data: {
                            TimeRecordingEntriesData: [
                                {
                                    Date: toISOOffset(date),
                                    WorkingTimeFrom: timeFrom,
                                    WorkingTimeUntil: null,
                                    WorkingType: 1,
                                    CustomWorkingType: 'N',
                                    Duration: 0,
                                    Index: 0,
                                    EmployeeIndex: 0,
                                    Text: '',
                                    CanDelete: false,
                                },
                            ],
                        },
                    };
                    loadJsonPost('/' + LocalStorage.getConnectionKey() + URLS.CreateTimeRecordingEntries, body).then((data: any) => {
                        setRunning(true);
                        loadTimeRecording();
                        sendMessage();
                    });
                }
                resetStopModal();
            }
        });
    }
    function resetStopModal() {
        setShowStopConfirm(false);
        setAddLunchBreak(true);
        setExtraText(null);
        setWorkingType(oldWorkingType);
    }
    return (
        <>
            {data && systemSettings && (
                <div className="time-recording">
                    <h3>{LocalStorage.getData('UserData').CombinedName}</h3>
                    <div className="time-recording-row">
                        <span className="time-recording-text">{window.Dictionary.getTranslation(6022)}:</span>
                        <button
                            className="time-recording-button"
                            id="time-recording-button"
                            style={{ backgroundColor: running ? 'var(--errorColor)' : 'var(--successColor)' }}
                            onClick={e => {
                                if (!running || !systemSettings?.WorkingTimes?.ShowSummaryAtStopTimeRecording) onStartStop();
                                else setShowStopConfirm(true);
                            }}>
                            {!running && <i className="icon-start" style={{ fontSize: '30px' }} />}
                            {running && <i className="icon-stop" style={{ fontSize: '30px' }} />}
                        </button>
                        {window.innerWidth > window.mobileBreakPoint && (
                            <>
                                <h1>{minuteToHHMM(timeRecording)}</h1>
                                {running && (
                                    <>
                                        <h4 style={{ marginLeft: '20px' }}>
                                            {
                                                workingTypes?.find((wt: any) => {
                                                    return wt.Value === workingType;
                                                })?.Name
                                            }
                                        </h4>
                                        <h4 style={{ marginLeft: '20px' }}>
                                            {window.Dictionary.getTranslation(16804)} : {startTime?.split('T')[1].substring(0, 5)}
                                        </h4>
                                    </>
                                )}
                            </>
                        )}
                        {window.innerWidth > window.mobileBreakPoint && Object.keys(props.designer?.DesignElements)?.length > 0 && data.Years && (
                            <div>
                                <div>
                                    <label>{window.Dictionary.getTranslation(3698)}</label>
                                    <select value={year} onChange={(e: any) => setYear(e.target.value)}>
                                        {data.Years?.map((y: any) => (
                                            <option value={y}>{y}</option>
                                        ))}
                                        <option value={Math.max(...data.Years) + 1}>{Math.max(...data.Years) + 1}</option>
                                    </select>
                                </div>
                                <div>
                                    <label>{window.Dictionary.getTranslation(3699)}</label>
                                    <select value={month} onChange={(e: any) => setMonth(e.target.value)}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                </div>
                            </div>
                        )}
                    </div>
                    {window.innerWidth <= window.mobileBreakPoint && (
                        <>
                            <div className="mobile-year-month">
                                <h1>{minuteToHHMM(timeRecording)}</h1>
                                <h4 style={{ marginLeft: '20px' }}>
                                    {
                                        workingTypes?.find((wt: any) => {
                                            return wt.Value === workingType;
                                        })?.Name
                                    }
                                </h4>
                            </div>
                            <div className="mobile-year-month">
                                <h4>
                                    {window.Dictionary.getTranslation(16804)} : {startTime?.split('T')[1].substring(0, 5)}
                                </h4>
                            </div>
                            {Object.keys(props.designer?.DesignElements)?.length > 0 && data.Years && (
                                <div className="mobile-year-month">
                                    <div>
                                        <label>{window.Dictionary.getTranslation(3698)}</label>
                                        <select value={year} onChange={(e: any) => setYear(e.target.value)}>
                                            {data.Years?.map((y: any) => (
                                                <option value={y}>{y}</option>
                                            ))}
                                            <option value={Math.max(...data.Years) + 1}>{Math.max(...data.Years) + 1}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label>{window.Dictionary.getTranslation(3699)}</label>
                                        <select value={month} onChange={(e: any) => setMonth(e.target.value)}>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                        </select>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    <div className={`mfx-view container-size mfx-detailview disable-true ${props.ViewName}`}>
                        <div
                            className="mfx-detailview-formelements"
                            style={{
                                gridTemplateColumns: 'repeat(' + (props?.designer?.Settings?.Columns ?? 2) + ', 1fr)',
                            }}>
                            {props.designer && props.designer.DesignElements && (
                                <>
                                    {Object.entries(props.designer.DesignElements)
                                        .sort((a: any, b: any) => {
                                            return a[1].Order > b[1].Order ? 1 : -1;
                                        })
                                        .map((key: any, idx) => {
                                            const designD = key[1];
                                            const keys = [key[1].Key];
                                            if (key[1].Key2) {
                                                keys.push(key[1].Key2);
                                            }
                                            return <GenericElement disableMode={true} customData={getValue(keys)} designData={{ ...designD }} key={idx + idx} index={idx} noLabel={false} />;
                                        })}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {showStopConfirm && (
                <ModalPopup
                    closeIcon={true}
                    closePopup={() => {
                        resetStopModal();
                        setShowStopConfirm(false);
                    }}>
                    <div>
                        <div className="save-message">
                            <h1>Arbeitszeiterfassung beenden</h1>
                        </div>
                        <div className="mfx-timerecording-stop-message">
                            <div>
                                <label>Datum</label>
                                <input type="date" disabled value={toDateFormat(new Date())} />
                            </div>
                            <div></div>
                            <div>
                                <label>Von</label>
                                <input type="time" disabled value={workingTimeRounding(new Date(startTime)).toTimeString().substring(0, 5)} />
                            </div>
                            <div>
                                <label>Bis</label>
                                <input type="time" disabled value={workingTimeRounding(new Date()).toTimeString().substring(0, 5)} />
                            </div>
                            <div className="full-width">
                                <label>Zusatztext</label>
                                <input type="text" onChange={e => setExtraText(e.target.value)} />
                            </div>
                            <div>
                                <label>Arbeitsart</label>
                                <select
                                    value={workingType}
                                    onChange={e => {
                                        setOldWorkingType(workingType);
                                        setWorkingType(e.target.value);
                                    }}>
                                    {workingTypes &&
                                        workingTypes.map(wt => (
                                            <option value={wt.Value} selected={wt.Value === workingType}>
                                                {wt.Name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            {JSON.parse(localStorage.getItem('UserData') as any)?.WorkingTimeLunchBreak !== '00:00:00' && getDurationInMinutesABS(workingTimeRounding(new Date(startTime)), workingTimeRounding(new Date())) >= 360 && (
                                <>
                                    <div className="mfx-checkbox-element">
                                        <input type="checkbox" checked={addLunchBreak} id="stop-timerecording-checkbox" onChange={e => setAddLunchBreak(e.target.checked)}></input>
                                        <label>Mittagspause hinzufügen</label>
                                    </div>
                                    <InputElement designData={{ Type: 'time', Label: 'Mittagspause von', Key: 'BreakFrom' }} customerData={breakFrom} onChangeHandler={e => setBreakFrom(e.newValue)} />

                                    <InputElement designData={{ Type: 'time', Label: 'Mittagspause bis', Key: 'BreakTo' }} customerData={breakTo} onChangeHandler={e => setBreakTo(e.newValue)} />
                                </>
                            )}
                        </div>
                        <div className="save-modal-buttons">
                            <button
                                className="mfx-button"
                                id="mfx-button-no"
                                onClick={() => {
                                    resetStopModal();
                                    setShowStopConfirm(false);
                                }}>
                                {window.Dictionary.getTranslation(40)}
                            </button>
                            <button className="mfx-button" id="mfx-button-yes" onClick={() => onStartStop()}>
                                {window.Dictionary.getTranslation(487)}
                            </button>
                        </div>
                    </div>
                </ModalPopup>
            )}
        </>
    );
}
